/* eslint-disable react-hooks/exhaustive-deps */
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ReplayIcon from '@mui/icons-material/Replay';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
  Table as TableMui,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  TableContainer
} from '@mui/material';
import { filter, get, isEmpty, map } from "lodash";
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DescriptionIcon from '@mui/icons-material/Description';

import Alert from "../../../components/form/Alert";
import Notification from "../../../components/form/Notification";
import Question from "../../../components/form/Question";
import Table from "../../../components/form/TableDetail";
import GeneratePdf from './pdfDocument';
import { pdf } from '@react-pdf/renderer';
import OrdersModal from "./OrdersModal";
import { useCanView } from "../../../config/hook/UserPermissions";
import { store } from "../../../store";

import { getInvoiceId } from "../../../store/transactions/thunk/invoice/getId";
import { postInvoiceDocument } from "../../../store/transactions/thunk/invoice/postInvoiceDocument";
import { postGeneateInvoiceDocument } from "../../../store/transactions/thunk/invoice/postGenerateInvoiceDoc";
import { postUploadInvoiceDetails } from "../../../store/transactions/thunk/invoice/postUploadInvoiceDetails";
import { deleteRouteInvoice } from "../../../store/transactions/thunk/invoice/deleteRouteInvoice";

const Orders = ({ setBtns, isEdit }) => {
  const [__] = useTranslation("invoice");
  const [__o] = useTranslation("order");
  const { id } = useParams();
  const canView = useCanView();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })
  const [openModal, setOpenModal] = useState(false);
  const [ordersSelectedFull, setOrdersSelectedFull] = useState([])
  const [openQuestion, setOpenQuestion] = useState({
    value: "",
    state: false
  });
  const [valueTotal, setValueTotal] = useState();
  const [toSelected, setToSelected] = useState({});
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null); 
  const [isLoading, setIsLoading] = useState(false); 
  const [toEdit, setToEdit] = useState({});

  const invoice = useSelector(state => state.transactions.invoice);
  const current = useSelector(state => state.transactions.invoice.detail);
  const post = useSelector(state => state.transactions.invoice.invoiceDetails);
  const user = useSelector(state => state.auth.login.dataUser);
  const delet = useSelector(state => state.transactions.invoice.deleteRoute);

  const document = useSelector(state => state.transactions.invoice.document);
  const documentGenerateInvocie = useSelector(state => state.transactions.invoice.documentGenerateInvocie);

  const getData = () => {
    dispatch(getInvoiceId({ id }))
  }
  const reload = async () => {
    await getData()
  }

  useEffect(() => {
    setOrdersSelectedFull(get(current, "data.detail", []))
  }, [get(current, "data.detail.length")])

  useEffect(() => {
    setBtns(
      <Stack className='mr-4' direction="row" spacing={1} justifyContent="flex-end" width="100%">
        {isEdit ? <Button className='' variant="contained" color="error" loading={get(document, "isLoading")} startIcon={<PictureAsPdfIcon />} onClick={ () => {
            if (canView("TRANSACCIONES/FACTURACIÓN CLIENTE/COBROS/PDF", "watch")) {
              handleGeneratePdf();
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para visualizar el PDF generado.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
        }}>Generar PDF</Button> : <div className='flex-1' />}
        {isEdit ? <LoadingButton className='' variant="contained" startIcon={<DescriptionIcon/>} color="secondary" loading={get(document, "isLoading")} disabled={get(current, "data.statusId") === 5} onClick={() => {
            if (canView("TRANSACCIONES/FACTURACIÓN CLIENTE/COBROS", "add")) {
              setOpenModal(true)
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para importar rutas a la factura.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
        }}>{__(`toolbar.billing`)}</LoadingButton> : <div className='flex-1' />}
        {isEdit ? <Button className='' startIcon={<AutorenewIcon/>} disabled={get(current, "data.detail.length") === 0 || get(current, "data.statusId") === 3 || get(current, "data.statusId") === 5} variant="contained" color="primary" onClick={() => {
            if (canView("TRANSACCIONES/FACTURACIÓN CLIENTE/COBROS/FACTURAR", "add")) {
              setOpenQuestion(prev => ({ ...prev, state: true, value: 'Facturar' }))
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para facturarle al cliente.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
        }}>{__(`toolbar.btn`)}</Button> : <div className='flex-1' />}
        <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
      </Stack>
    )
  }, [isEdit, get(current, "data.statusId")])

  const handleGeneratePdf = async () => {
    setIsLoading(true);
    try {
      await dispatch(getInvoiceId({ id })); // solo lo actualiza en redux
      const state = store.getState(); 
      const values = state.transactions.invoice.detail; 
      const doc = <GeneratePdf values={values} />; 
      const blob = await pdf(doc).toBlob(); 
      const blobUrl = URL.createObjectURL(blob); 
      setPdfBlobUrl(blobUrl); 
      window.open(blobUrl, '_blank');

    } catch (error) {

      setAlert({
        open: true,
        title: "Error al Generar el PDF",
        subtitle: (<ul>  <li>• Error: {error}</li> </ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      });

    } finally {

      setIsLoading(false);
      
    }
  };

  const HandleBillings = (billingSelected) => {
    const body = {
      id:  Number(id),
      routes: billingSelected,
    }
    dispatch(postInvoiceDocument(body))
  }

  const handleOpenMenu = (row) => (event) => {
    setToSelected(get(row, "idRoute"))
    setAnchorEl(event.currentTarget);
  };

  const onCancel = () => {
    setAnchorEl(null);
    setSelected({})
    setOpenModal(false)
    setOpenQuestion(prev => ({ ...prev, state: false, value: '' }))
    setValueTotal(0)
    setToEdit({})
    setToSelected({})
  };

  const onSuccess = () => {

    if (openQuestion.value === 'Eliminar') { 
      
      const body = {
        billingTranckingId: Number(id),
        idRoute: Number(toSelected),
        idUser: get(user, "idUser")
      }
      setToSelected();
      dispatch(deleteRouteInvoice(body));

    } else if (openQuestion.value === 'Facturar') {
      dispatch(postGeneateInvoiceDocument(id));
    }
  };

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    setOpenQuestion(prev => ({ ...prev, state: false, value: '' }))
  };

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
    onCancel()
  }

  useEffect(() => {
    if (get(post, "isSuccess", false)) { setOpenQuestion(prev => ({ ...prev, state: false, value: '' })); onCancel(); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(post, "isReject", false)) { setError(get(post, "error", {}), "put") }
    if (get(document, "isSuccess", false)) { setOpenQuestion(prev => ({ ...prev, state: false, value: '' })); onCancel(); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(document, "isReject", false)) { setError(get(document, "error", {}), "put") }
    if (get(documentGenerateInvocie, "isSuccess", false)) { setOpenQuestion(prev => ({ ...prev, state: false, value: '' })); onCancel(); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(documentGenerateInvocie, "isReject", false)) { setError(get(document, "error", {}), "put") }
    if (get(delet, "isSuccess", false)) { setOpenQuestion(prev => ({ ...prev, state: false, value: '' })); onCancel(); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
  }, [post, document, documentGenerateInvocie, delet])

   const handleDelete = (row) => () => {
    setAnchorEl(null)
    setOpenQuestion(prev => ({ ...prev, state: true, value: 'Eliminar' }))
    setToSelected(row)
  }

  useEffect(() => {
    if (Object.keys(current.data).length > 0) {
      const totalMonto = current.data.detail.reduce((sum, item) => sum + item.monto, 0);
      setValueTotal(totalMonto);
    }
  }, [current]);

  const headTable = [
    {
      key: "idRoute",
      label: __(`table.colsOrders.idRuote`),
      align: "center"
    },
    {
      key: "dateToRoute",
      label: __(`table.colsOrders.dateToRoute`),
      align: "center"
    },
    {
      key: "proveedor",
      label: __(`table.colsOrders.proveedor`),
      align: "center",
    },
    {
      key: "division",
      label: __(`table.colsOrders.division`),
      align: "center",
    },
    {
      key: "puntoCarga",
      label: __(`table.colsOrders.puntoCarga`),
      align: "center",
    },
    {
      key: "puntoEntrega",
      label: __(`table.colsOrders.puntoEntrega`),
      align: "center",
    },
    {
      key: "price",
      label: __(`table.colsOrders.price`),
      align: "center",
    },
    {
      key: "options",
      label: __(`table.cols.options`),
      align: "center",
      sx: { position: "sticky", right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    }
  ]

  const dataTable = map(get(current, "data.detail", []), (row, i) => ({
    ...row,
    dateToRoute: get(row, "dateToRoute", "").split('T')[0],
    price: `$ ${get(row, "monto", 0)?.toFixed(2)}`,
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>,
    servicios: get(row, "servicios")
  }));

  const getQuestionTitle = () => {
    switch (openQuestion.value) {
        case "Eliminar":
            return __("alert.deleteOrder.title"); 
        case "Facturar":
            return __("alert.billing.title"); 
    }
  };
  
  const getQuestionDetail= () => {
    switch (openQuestion.value) {
        case 'Eliminar':
            return __("alert.deleteOrder.detail"); 
        case 'Facturar':
            return __("alert.billing.detail"); 
    }
  };

  return (
    <div>
      <Table 
        headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        loading={get(current, "isLoading", false)}
        empty="orders"
      />
      {valueTotal > 0 && <Paper>
        <TableContainer>
          <TableMui aria-label="table">
            <TableBody >
              <TableRow key={1}>
                <TableCell key={2} align="left">
                  <Typography variant="bodySmall" component="h2">TOTAL RUTAS: {get(current, "data.detail", []).length}</Typography>
                </TableCell>
                <TableCell key={1} align="right" >
                  <Typography variant="bodySmall" component="h2" >TOTAL: ${valueTotal.toFixed(2)}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </TableMui>
        </TableContainer>
      </Paper>}
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={onCancel}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <MenuItem onClick={ () => {
          if (canView("TRANSACCIONES/FACTURACIÓN CLIENTE/COBROS", "delete")) {
            handleDelete(toSelected)()
          } else {
            setAlert({
              open: true,
              title: "Permiso Denegado.",
              subtitle: (<ul> • No tienes permiso para eliminar cobros de la factura del cliente.</ul>),
              type: "error",
              btn: __(`${module}.actions.close`),
              func: closeAlert
            })
          }
        }}>{__(`table.menu.delete`)}</MenuItem>
      </Menu>
      <OrdersModal
        __={__}
        open={openModal}
        close={() => setOpenModal(false)}
        billings = {HandleBillings}
      />
      <Question
        title={getQuestionTitle()}
        detail={getQuestionDetail()}
        onSuccess={onSuccess}
        onCancel={() => setOpenQuestion(prev => ({ ...prev, state: false, value: '' }))}
        open={openQuestion.state}
        loading={get(delet, "isLoading")}
      />
    </div >
  )
}

export default Orders;
